<div class="modal__header">
  <span class="title">
    {{ scenario === 'analysis' ? 'Анализ ранее распределённых заявок' : 'Автоматическое распределение' }}
    <ng-container *ngIf="step === 'gpsType' && distributionDate">на {{ getDistributionDateLabel() }}</ng-container>
  </span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()"></div>
</div>

<div class="modal__body">
  <div class="automatic-settings__group" *ngIf="step === 'distributionType'">
    <div class="automatic-settings__sector-options" *ngIf="sectorOptionsLoading">
      <app-loader [size]="'small'" [position]="'reset'"></app-loader>
      <span>Загрузка настроек участка...</span>
    </div>
    <div class="automatic-settings__sector-options" *ngIf="!sectorOptionsLoading && sectorOptionsApplied">
      Подставлены сохранённые настройки участка
    </div>
    <div class="automatic-settings__distribution-layout">
      <div class="automatic-settings__distribution-column">
    <div class="title title--s mb-8">Тип распределения</div>

    <div class="automatic-settings__option">
      <app-radio-button>
        <input type="radio" name="automaticDistributionType" [checked]="!allowUnassigned" (change)="allowUnassigned = false" />
        <radio-button-text>Частичное распределение</radio-button-text>
      </app-radio-button>
    </div>

    <div class="automatic-settings__option">
      <app-radio-button>
        <input type="radio" name="automaticDistributionType" [checked]="allowUnassigned" (change)="allowUnassigned = true" />
        <radio-button-text>Полное распределение</radio-button-text>
      </app-radio-button>
    </div>

    <div class="automatic-settings__subgroup">
      <div class="title title--s mb-8">Тип отображения</div>

      <div class="automatic-settings__option" [class.automatic-settings__option--disabled]="isAssignModeAvailable">
        <app-radio-button>
          <input
            type="radio"
            name="automaticDistributionLaunchMode"
            [checked]="launchMode === 'preview'"
            [disabled]="isAssignModeAvailable"
            (change)="launchMode = 'preview'"
          />
          <radio-button-text>Предпросмотр</radio-button-text>
        </app-radio-button>
      </div>

      <div
        *ngIf="showAssignMode"
        class="automatic-settings__option"
        [class.automatic-settings__option--disabled]="alreadyDistributedToday"
      >
        <app-radio-button>
          <input
            type="radio"
            name="automaticDistributionLaunchMode"
            [checked]="launchMode === 'assign'"
            [disabled]="alreadyDistributedToday"
            (change)="launchMode = 'assign'"
          />
          <radio-button-text>Распределить и Сохранить</radio-button-text>
        </app-radio-button>
        <span
          *ngIf="alreadyDistributedToday"
          class="info-icon"
          [ngbPopover]="'По данному участку сегодня уже производилось распределение или время больше 10 часов дня'"
          triggers="mouseenter:mouseleave"
          placement="right"
          aria-label="По данному участку сегодня уже производилось распределение или время больше 10 часов дня"
          >i</span
        >
      </div>
    </div>

    <div class="automatic-settings__subgroup">
      <div class="title title--s mb-8">Стратегия распределения</div>

      <div class="automatic-settings__option">
        <app-radio-button>
          <input
            type="radio"
            name="distributionStrategy"
            [checked]="distributionStrategy === 'minimize_total_travel_time'"
            (change)="distributionStrategy = 'minimize_total_travel_time'"
          />
          <radio-button-text>Минимум времени в пути</radio-button-text>
        </app-radio-button>
        <span class="info-icon" [ngbPopover]="'Минимальным количеством людей, минимальным расстоянием'" triggers="mouseenter:mouseleave" placement="right">i</span>
      </div>

      <div class="automatic-settings__option">
        <app-radio-button>
          <input type="radio" name="distributionStrategy" [checked]="distributionStrategy === 'balanced_distribution'" (change)="distributionStrategy = 'balanced_distribution'" />
          <radio-button-text>Равномерное распределение</radio-button-text>
        </app-radio-button>
        <span class="info-icon" [ngbPopover]="'Равное количество заявок на человека'" triggers="mouseenter:mouseleave" placement="right">i</span>
      </div>

      <div class="automatic-settings__option">
        <app-radio-button>
          <input type="radio" name="distributionStrategy" [checked]="distributionStrategy === 'priority_based'" (change)="distributionStrategy = 'priority_based'" />
          <radio-button-text>По приоритету заявок</radio-button-text>
        </app-radio-button>
        <span class="info-icon" [ngbPopover]="'Учитывая приоритет аварийных заявок'" triggers="mouseenter:mouseleave" placement="right">i</span>
      </div>
    </div>
      </div>

      <div class="automatic-settings__distribution-column">
        <div class="title title--s mb-8">Распределение по районам</div>

        <div class="automatic-settings__option">
          <app-radio-button>
            <input
              type="radio"
              name="districtDistributionStrategy"
              [checked]="limitationType === 1"
              (change)="limitationType = 1"
            />
            <radio-button-text>Отключено</radio-button-text>
          </app-radio-button>
        </div>

        <div class="automatic-settings__option">
          <app-radio-button>
            <input
              type="radio"
              name="districtDistributionStrategy"
              [checked]="limitationType === 2"
              (change)="limitationType = 2"
            />
            <radio-button-text>Гибкая стратегия</radio-button-text>
          </app-radio-button>
          <span
            class="info-icon"
            [ngbPopover]="'Приоритет отдаётся СИ, которые закреплены за районом выполнения заявки. Также СИ может привлекаться на соседние районы.'"
            triggers="mouseenter:mouseleave"
            placement="right"
            aria-label="Описание гибкой стратегии распределения по районам"
            >i</span
          >
        </div>

        <div class="automatic-settings__option">
          <app-radio-button>
            <input
              type="radio"
              name="districtDistributionStrategy"
              [checked]="limitationType === 3"
              (change)="limitationType = 3"
            />
            <radio-button-text>Жесткая стратегия</radio-button-text>
          </app-radio-button>
          <span
            class="info-icon"
            [ngbPopover]="'Приоритет отдаётся СИ, которые закреплены за районом выполнения заявки. СИ может выполнять заявки только в своём районе.'"
            triggers="mouseenter:mouseleave"
            placement="right"
            aria-label="Описание жёсткой стратегии распределения по районам"
            >i</span
          >
        </div>
      </div>
    </div>

  </div>

  <div class="automatic-settings__group" *ngIf="step === 'gpsType'">
    <div class="automatic-settings__analysis-statuses" *ngIf="scenario === 'analysis' && !employeesLoading && !employeesError">
      <app-field>
        <label>Статусы заявок</label>
        <app-select-multiple
          [initBy]="ticketStatusesSelected"
          [initByKey]="'id'"
          [items]="ticketStatuses"
          [textKey]="'name'"
          (callback)="setTicketStatuses($event)"
        ></app-select-multiple>
      </app-field>
    </div>

    <div class="title title--s mb-8">Источник координат</div>

    <div
      class="automatic-settings__option"
      [class.automatic-settings__option--disabled]="employeesLoading || employeesError || !hasEmployeeWithGpsCoordinate"
    >
      <app-radio-button>
        <input
          type="radio"
          name="automaticDistributionGpsType"
          [checked]="gpsType === 1"
          [disabled]="employeesLoading || employeesError || !hasEmployeeWithGpsCoordinate"
          (change)="setGpsType(1)"
        />
        <radio-button-text>Мобильный телефон сотрудника</radio-button-text>
      </app-radio-button>
      <span
        *ngIf="!employeesLoading && !employeesError && !hasEmployeeWithGpsCoordinate"
        class="info-icon"
        [ngbPopover]="'Ни у одного сотрудника нет GPS-координаты'"
        triggers="mouseenter:mouseleave"
        placement="right"
        aria-label="Ни у одного сотрудника нет GPS-координаты"
        >i</span
      >
    </div>

    <div class="automatic-settings__option">
      <app-radio-button>
        <input type="radio" name="automaticDistributionGpsType" [checked]="gpsType === 2" [disabled]="employeesLoading || employeesError" (change)="setGpsType(2)" />
        <radio-button-text>Координаты офиса</radio-button-text>
      </app-radio-button>
    </div>

    <div class="automatic-settings__option" *ngIf="gpsType === null">
      <app-radio-button>
        <input type="radio" name="automaticDistributionGpsType" [checked]="true" [disabled]="employeesLoading || employeesError" (change)="setGpsType(null)" />
        <radio-button-text>По сотрудникам</radio-button-text>
      </app-radio-button>
      <span
        class="info-icon"
        [ngbPopover]="'У сотрудников разные источники координат — они заданы каждому отдельно в расширенной настройке ниже'"
        triggers="mouseenter:mouseleave"
        placement="right"
        aria-label="У сотрудников разные источники координат — они заданы каждому отдельно в расширенной настройке ниже"
        >i</span
      >
    </div>

    <div class="automatic-settings__employees-state" *ngIf="employeesLoading">
      <app-loader [size]="'small'" [position]="'reset'"></app-loader>
      <span>Загрузка сотрудников...</span>
    </div>

    <div class="automatic-settings__employees-state automatic-settings__employees-state--error" *ngIf="employeesError">
      <span>{{ scenario === 'analysis' ? 'Не удалось загрузить сотрудников или статусы заявок.' : 'Не удалось загрузить сотрудников.' }}</span>
      <button class="link link--dotted-blue-dark" type="button" (click)="loadEmployees()">Повторить</button>
    </div>

    <ng-container *ngIf="!employeesLoading && !employeesError">
      <div class="automatic-settings__advanced-toggle">
        <app-checkbox>
          <input type="checkbox" [checked]="advancedSettings" (change)="advancedSettings = $event.target.checked" />
          <checkbox-text>Расширенная настройка</checkbox-text>
        </app-checkbox>
        <span class="automatic-settings__employees-count">Сотрудников на смене: {{ employees.length }}</span>
      </div>

      <div class="automatic-settings__employees-empty" *ngIf="!employees.length">Для выбранного участка сотрудники не найдены.</div>

      <!-- Командировочный не закреплён за районами этого участка, поэтому районы для него выбирает диспетчер.
           Блок можно скрыть — тогда уходят все районы участка -->
      <ng-container *ngIf="advancedSettings && hasTripDistrictsSettings">
        <div class="automatic-settings__trip-districts" *ngIf="!tripDistrictsHidden">
          <div class="automatic-settings__trip-districts-header">
            <span class="title title--s">
              Районы командировочных
              <span
                class="info-icon"
                [ngbPopover]="'Заявки командировочному сотруднику подбираются только из выбранных районов участка. По умолчанию выбраны все районы; если снять все — районы не передаются.'"
                triggers="mouseenter:mouseleave"
                placement="right"
                aria-label="Описание настройки районов командировочных сотрудников"
                >i</span
              >
            </span>
            <a class="link link--dotted-gray-dark automatic-settings__trip-districts-toggle" (click)="toggleTripDistrictsHidden()">Скрыть</a>
          </div>
          <div class="automatic-settings__trip-district" *ngFor="let employee of tripEmployees; trackBy: trackByEmployeeId">
            <span class="automatic-settings__trip-district-name" [title]="getEmployeeName(employee)">{{ getEmployeeName(employee) || 'Сотрудник' }}</span>
            <span class="automatic-settings__employee-gph" *ngIf="isEmployeeGph(employee)" title="Работает по договору ГПХ">ГПХ</span>
            <div class="automatic-settings__trip-district-select">
              <app-select-multiple
                [items]="districts"
                [textKey]="'district_name'"
                [initBy]="employee.districts"
                [initByKey]="'d_id'"
                [defaultText]="'Районы не выбраны'"
                (callback)="setEmployeeDistricts(employee, $event)"
              ></app-select-multiple>
            </div>
          </div>
        </div>
        <div class="automatic-settings__trip-districts-hidden" *ngIf="tripDistrictsHidden">
          <a class="link link--dotted-gray-dark automatic-settings__trip-districts-toggle" (click)="toggleTripDistrictsHidden()">Показать районы командировочных</a>
        </div>
      </ng-container>

      <div class="automatic-settings__employees-table-wrap" *ngIf="advancedSettings && employees.length">
        <table class="automatic-settings__employees-table">
          <thead>
            <tr>
              <th>ФИО</th>
              <th>Координаты</th>
              <th>Тип движения</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let employee of employees; trackBy: trackByEmployeeId">
              <td class="automatic-settings__employee-cell">
                <div class="automatic-settings__employee-summary">
                  <div class="automatic-settings__employee-details">
                    <div class="automatic-settings__employee-name">{{ getEmployeeName(employee) || 'Сотрудник' }}</div>
                    <span class="automatic-settings__employee-gph" *ngIf="isEmployeeGph(employee)" title="Работает по договору ГПХ">ГПХ</span>
                    <div class="automatic-settings__employee-trip" *ngIf="isEmployeeOnTrip(employee)" title="Сотрудник в командировке">Командировка</div>
                    <div class="automatic-settings__employee-meta" *ngIf="getEmployeeMeta(employee)">{{ getEmployeeMeta(employee) }}</div>
                    <!-- У командировочного график лежит в другом участке: время смены задаёт диспетчер -->
                    <div class="automatic-settings__employee-shift" *ngIf="isEmployeeOnTrip(employee)">
                      <span class="automatic-settings__employee-shift-label">Смена</span>
                      <input
                        type="text"
                        class="input-text automatic-settings__employee-shift-input"
                        mask="00:00"
                        placeholder="--:--"
                        title="Начало смены"
                        [(ngModel)]="employee.shift_begin"
                        (blur)="commitEmployeeShiftBegin(employee)"
                      />
                      <span class="automatic-settings__employee-shift-dash">–</span>
                      <input
                        type="text"
                        class="input-text automatic-settings__employee-shift-input"
                        mask="00:00"
                        placeholder="--:--"
                        title="Окончание смены"
                        [(ngModel)]="employee.shift_end"
                        (blur)="commitEmployeeShiftEnd(employee)"
                      />
                    </div>
                  </div>
                  <div class="automatic-settings__employee-indicators">
                    <app-icon
                      [glyph]="employee.car ? 'car' : 'run'"
                      [size]="'16'"
                      [color]="'gray'"
                      [attr.title]="employee.car ? 'Есть автомобиль' : 'Пешком'"
                    ></app-icon>
                  </div>
                </div>
              </td>
              <td>
                <div
                  class="automatic-settings__employee-option"
                  [class.automatic-settings__employee-option--disabled]="isEmployeeCoordinateTypeDisabled(employee, 2)"
                  [attr.title]="isEmployeeCoordinateTypeDisabled(employee, 2) ? 'У сотрудника нет GPS-координаты' : null"
                >
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeCoordinateType' + employee.user_id"
                      [checked]="employee.coordinate_type === 2"
                      [disabled]="isEmployeeCoordinateTypeDisabled(employee, 2)"
                      (change)="setEmployeeCoordinateType(employee, 2)"
                    />
                    <radio-button-text>Телефон/GPS</radio-button-text>
                  </app-radio-button>
                  <a
                    class="automatic-settings__employee-location"
                    *ngIf="getEmployeeMapUrl(employee) as employeeMapUrl"
                    [href]="employeeMapUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Открыть GPS-координату на OpenStreetMap"
                    aria-label="Открыть GPS-координату на OpenStreetMap"
                  >
                    <app-icon [glyph]="'geolocation'" [size]="'16'" [color]="'blue-dark'"></app-icon>
                  </a>
                </div>
                <div class="automatic-settings__employee-option">
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeCoordinateType' + employee.user_id"
                      [checked]="employee.coordinate_type === 1"
                      (change)="setEmployeeCoordinateType(employee, 1)"
                    />
                    <radio-button-text>Офис/участок</radio-button-text>
                  </app-radio-button>
                </div>
                <div
                  class="automatic-settings__employee-option"
                  [class.automatic-settings__employee-option--disabled]="isEmployeeCoordinateTypeDisabled(employee, 3)"
                  [attr.title]="isEmployeeCoordinateTypeDisabled(employee, 3) ? 'У сотрудника нет координат дома' : null"
                >
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeCoordinateType' + employee.user_id"
                      [checked]="employee.coordinate_type === 3"
                      [disabled]="isEmployeeCoordinateTypeDisabled(employee, 3)"
                      (change)="setEmployeeCoordinateType(employee, 3)"
                    />
                    <radio-button-text>Дом</radio-button-text>
                  </app-radio-button>
                  <a
                    class="automatic-settings__employee-location"
                    *ngIf="getEmployeeHomeMapUrl(employee) as employeeHomeMapUrl"
                    [href]="employeeHomeMapUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Открыть координаты дома на OpenStreetMap"
                    aria-label="Открыть координаты дома на OpenStreetMap"
                  >
                    <app-icon [glyph]="'home'" [size]="'16'" [color]="'blue-dark'"></app-icon>
                  </a>
                </div>
              </td>
              <td>
                <div class="automatic-settings__employee-option">
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeMovementType' + employee.user_id"
                      [checked]="employee.movement_type === 1"
                      (change)="setEmployeeMovementType(employee, 1)"
                    />
                    <radio-button-text>
                      <app-icon [glyph]="'walk'" [size]="'16'" [color]="'gray'"></app-icon>
                      Пешком
                    </radio-button-text>
                  </app-radio-button>
                </div>
                <div class="automatic-settings__employee-option">
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeMovementType' + employee.user_id"
                      [checked]="employee.movement_type === 2"
                      (change)="setEmployeeMovementType(employee, 2)"
                    />
                    <radio-button-text>
                      <app-icon [glyph]="'car'" [size]="'16'" [color]="'gray'"></app-icon>
                      Автомобиль
                    </radio-button-text>
                  </app-radio-button>
                </div>
                <div
                  class="automatic-settings__employee-option"
                  [class.automatic-settings__employee-option--disabled]="!publicTransportEnabled"
                >
                  <app-radio-button>
                    <input
                      type="radio"
                      [name]="'employeeMovementType' + employee.user_id"
                      [checked]="employee.movement_type === 3"
                      [disabled]="!publicTransportEnabled"
                      (change)="setEmployeeMovementType(employee, 3)"
                    />
                    <radio-button-text>
                      <app-icon [glyph]="'bus'" [size]="'16'" [color]="'gray'"></app-icon>
                      Общественный транспорт
                    </radio-button-text>
                  </app-radio-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal__footer">
  <div class="modal__footer-action automatic-settings__footer-actions" *ngIf="step === 'distributionType'">
    <button class="button automatic-settings__analysis-button" type="button" [disabled]="!isAnalysisAvailable || sectorOptionsLoading" (click)="startAnalysis()">
      Анализ
      <span
        class="info-icon"
        [ngbPopover]="'Анализ ранее распределённых заявок'"
        triggers="mouseenter:mouseleave"
        placement="top"
        aria-label="Анализ ранее распределённых заявок"
        >i</span
      >
    </button>
    <button class="button" type="button" [disabled]="!isDistributionAvailable || sectorOptionsLoading" (click)="nextStep()">Продолжить</button>
  </div>
  <div class="modal__footer-action" *ngIf="step === 'gpsType'">
    <button class="button" type="button" [disabled]="employeesLoading || employeesError" (click)="submit()">
      {{ scenario === 'analysis' ? 'Запустить анализ' : 'Запустить' }}
    </button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" *ngIf="step === 'distributionType'" (click)="activeModal.dismiss()">Отмена</a>
    <a class="link link--dotted-blue-dark" *ngIf="step === 'gpsType'" (click)="previousStep()">Назад</a>
  </div>
</div>
